<template>
	<div class="nav-bar-container">
		 头
	</div>
</template>

<script>
	var timer, flag = false;
	import {
		mapActions,
		mapGetters
	} from 'vuex'
	export default {
		name: 'VabNavBar',
		data() {
			return {
				pulse: false,
			}
		},
		computed: {
		 
		},
		created() {
			try {
				let that = this;
			 
			} catch (e) { 
				console.error("cecece", e)
			}
		},
		methods: { 
		 
		},
	}
</script>

<style lang="scss" scoped>
	 
</style>



// WEBPACK FOOTER //
// index.vue?9af27850